<template>
	<div class="content">
		 <van-loading type="spinner" class='loading' color="#1989fa" />
		<van-nav-bar
		  title="预约信息"
		  left-arrow
		 />
		<van-cell-group class="box">
		  <p class="box_header">填写预约信息表</p>
		  <van-field
		    v-model="text"
		    clearable
		    label="姓名"
		    left-icon="manager"
		    required
		    placeholder="请输入姓名"
		    class='icon_color1'
		  />
		  <van-field
		    v-model="phone"
		    clearable
		    required
		    label="手机号"
		    left-icon="phone-circle"
		    placeholder="请输入被访人电话"
		     class='icon_color2'
		  />
		  <van-field
		      label="开始时间"
		      required
		      left-icon="clock"
		      :value-class="className"
		      :value="timeValue"
		      @click="showPopup" 
		       class='icon_color3'
		      />
		    <van-popup v-model="show" position="bottom">
		      <van-datetime-picker
		        v-model="currentDate"
		        type="datetime"
		        title="选择时间"
		        :loading="isLoadingShow"
		        :min-date="minDate"
		        :max-date="maxDate"
		        :formatter="formatter"
		        @cancel="show = false"
		        @confirm="confirmPicker"
		        
		      />
		    </van-popup>
		    
		   <van-field
		      label="结束时间"
		      required
		      left-icon="clock"
		      :value-class="endclassName"
		      :value="endtimeValue"
		      @click="endshowPopup"
		       class='icon_color4'
		       />
		    <van-popup v-model="endshow" position="bottom">
		      <van-datetime-picker
		        v-model="endcurrentDate"
		        type="datetime"
		        title="选择时间"
		        :loading="isLoadingShow"
		        :min-date="endminDate"
		        :max-date="endmaxDate"
		        :formatter="formatter"
		        @cancel="endshow = false"
		        @confirm="endconfirmPicker"
		        
		      />
		    </van-popup>
		 
		
		  <van-field
			  v-model="message"
			  rows="1"
			  clearable
			  class='icon_color5'
			  required
			  autosize
			  label="拜访事由"
			  left-icon="comment"
			  type="textarea"
			  placeholder="请输入拜访事由"
			  
			/>
		</van-cell-group>
		 <van-button  type="primary" @click="confirm()" class="button_confirm">预约</van-button>
	 
		<van-tabbar v-model="active">
		 <van-tabbar-item icon="home-o"><router-link to="/wx_index" class="router activerouter" >我的预约</router-link></van-tabbar-item>
		 <van-tabbar-item icon="search"><router-link to="/wx_visit" class="router">我的访问</router-link></van-tabbar-item>
		 <van-tabbar-item icon="setting-o"><router-link to="/wx_center" class="router">个人中心</router-link></van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	
	
  export default {
  data () {
    return {
    	  phone:'',
   	      active: 0,
		  text: '',
	      message:'',
	      timeValue: '请选择时间',
	      endtimeValue: '请选择时间',
	      show: false,
	      endshow: false,
		  isLoadingShow: true,
	      currentDate: new Date(),
	      endcurrentDate: new Date(),
	      minDate: new Date(),
	      maxDate: new Date(2050, 12, 31),
	      endminDate: new Date(),
	      endmaxDate: new Date(2050, 12, 31),
	      className: '',
	      endclassName:''
	    }
    },
    mounted() {
    	this.time();
    },
    methods: {
    	
		getCode () { // 非静默授权，第一次有弹框
                this.code = ''
                var local = window.location.href // 获取页面url
                var appid = 'wxc5122a1d3db64e92' 
                this.code = this.getUrlCode().code // 截取code
                if (this.code == null || this.code === '') { // 如果没有code，则去请求
                    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect"
                } else {
                    // 你自己的业务逻辑
                    
                    console.log("成功")
                }
            },
		getUrlCode() { // 截取url中的code方法
                var url = location.search
                this.winUrl = url
                var theRequest = new Object()
                if (url.indexOf("?") !== -1) {
                    var str = url.substr(1)
                    var strs = str.split("&")
                    for(var i = 0; i < strs.length; i ++) {
                        theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
                    }
                }
                return theRequest
            },	
		confirm(){
			    this.$dialog.alert({
			      message: '预约成功，等待审核',
			    });
		},
		
	    showPopup () {
	      this.show = true
	      this.isLoadingShow = true
	      setTimeout(() => {
	        this.isLoadingShow = false
	      }, 500)
	    },
	    endshowPopup () {
	      this.endshow = true
	      this.isLoadingShow = true
	      setTimeout(() => {
	        this.isLoadingShow = false
	      }, 500)
	    },
	    confirmPicker (val) {//开始时间
	      let year = val.getFullYear()
	      let month = val.getMonth() + 1
	      let day = val.getDate()
	      let hour = val.getHours()
	      let minute = val.getMinutes();
	      let seconds=val.getSeconds()<10 ? "0"+val.getSeconds() : val.getSeconds();
	      if (month >= 1 && month <= 9) { month = `0${month}` }
	      if (day >= 1 && day <= 9) { day = `0${day}` }
	      if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
	      if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
	      this.className = 'timeClass'
	      this.timeValue = `${year}-${month}-${day} ${hour}:${minute}:${seconds}`
	      this.show = false
	    },
	    endconfirmPicker (vala) {//结束时间
	      let year = vala.getFullYear()
	      let month = vala.getMonth() + 1
	      let day = vala.getDate()
	      let hour = vala.getHours()
	      let minute = vala.getMinutes()
	      let seconds=vala.getSeconds()<10 ? "0"+vala.getSeconds() : vala.getSeconds();
	      if (month >= 1 && month <= 9) { month = `0${month}` }
	      if (day >= 1 && day <= 9) { day = `0${day}` }
	      if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
	      if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
	      this.endclassName = 'timeClass'
	      this.endtimeValue = `${year}-${month}-${day} ${hour}:${minute}:${seconds}`
	      this.endshow = false
	    },
	    // 选项格式化函数
	    formatter (type, value) {
	      if (type === 'year') {
	        return `${value}年`
	      } else if (type === 'month') {
	        return `${value}月`
	      } else if (type === 'day') {
	        return `${value}日`
	      } else if (type === 'hour') {
	        return `${value}时`
	      } else if (type === 'minute') {
	        return `${value}分`
	      } else if (type === 'second') {
	        return `${value}秒`
	      }
	      return value
	    },
	    
	    time(){
	    	  this.timeValue=this.dateFormat();
	    	  this.endtimeValue=this.enddataFormat();
	    },
	    dateFormat() {//获取当前时间
	    	var date=new Date();
	        var year=date.getFullYear();
	        var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	        var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
	        var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
	        var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
	        var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
	        // 拼接
	        return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
	        },
	     enddataFormat(){//获取今天结束时间默认23：59:59秒
	     	const start = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);
			var date;
			date= new Date(start)
			var year=date.getFullYear();
	        var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
	        var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
	        var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
	        var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
	        var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
			return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
	     }
    }
  
}
</script>

<style >
	.icon_color1 i {
		color:#1989fa;
	}
	.icon_color2 i {
		color:#19c160;
	}
	.icon_color3 i {
		color:#07c160;
	}
	.icon_color4 i {
		color:#4fc08d;
	}
	.icon_color5 i {
		color:#2989fa;
	}
	.content{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}
	.box{
		width: 90%;
		margin-top: 20px;
		margin-left: 5%;
		background-color: #97CBFF;
	}
	.box_header{
		height: 40px;
		line-height: 40px;
		color: #000000;
		font-size: 15px;
		font-weight: 600;
		text-align: center;
		background-color: #F0EFED;
	}
	.button_confirm{
		width:90%;
		margin-left: 5%;
		margin-top: 60px;
		background-color: #1171CD;
		border: 0px;
	}
	
	.router{
		color: #646566;
	}
	.activerouter{
		color: #1989fa;
	}
	.loading{
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatvisitors/wx_index.vue